export * from './lib/ui-dialog.component';
